export const pickerStyles = {
  inputClass: 'flex-1 min-w-0 px-3 h-10 border-2 border-black rounded',
  buttonClass: 'flex items-center w-max mr-3 p-1.5 bg-white border-2 border-black rounded',
  imgClass: 'h-[20px] mr-1.5',
  textClass: 'mr-1.5',
  indicatorClass: 'triangle-lg',
};

export const selectStyles = {
  container: (provided: any) => ({
    ...provided,
    marginTop: 8,
  }),
  control: (provided: any) => ({
    width: 336,
    backgroundColor: '#FFFFFF',
    border: '2px solid #000000',
    borderBottom: 0,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    '&:hover': {
      borderColor: '#000000',
    },
    '&:focus': {
      borderColor: '#000000',
    },
  }),
  indicatorsContainer: () => ({
    display: 'none',
  }),
  menu: (provided: any) => ({
    ...provided,
    margin: 0,
    padding: '5px 5px 5px 0',
    width: '100%',
    border: '2px solid #000000',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  }),
  menuList: (provided: any) => ({
    ...provided,
    padding: 0,
    overflowX: 'hidden',
    maxHeight: 170,
    '::-webkit-scrollbar': {
      width: '5px',
      height: '0',
    },
    '::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '::-webkit-scrollbar-thumb': {
      background: '#000000',
      borderRadius: '10px',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    whiteSpace: 'nowrap',
    padding: '6px 10px',
    margin: 0,
    '&:active': {
      backgroundColor: '#9CA3AF',
    },
    cursor: 'pointer',
    backgroundColor: state.isFocused ? '#EBEBEB' : '#FFFFFF',
    ...(state.isSelected && { fontWeight: 600, color: '#000000' }),
  }),
};
